import React, {useEffect, useState} from "react";
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import OffersChoiceResultService from "services/OffersChoiceResultService";
import useSearch from "hooks/useSearch";
import BasicSearch from "components/BasicSearch";
import Tr from "translations/Translations";
import {connect} from "react-redux";
import Loading from "components/Loading";
import BoldTypography from "components/BoldTypography";
import Pagination from "components/Pagination";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";
import OfferChoiceResultTable from "./components/OfferChoiceResultTable";
import DemandValidationMessages from "components/DemandValidationMessages";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    }
}));

function OffersChoiceResult(
    {
        match,
        offerChoiceResultList,
        demandValidation
    }) {
    const classes = useStyles();
    const curDemandValidation = DemandValidation.OFFERS_CHOICE_RESULT;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;
    const canDownloadPaper = section ? section.canDownloadPaper : false;
    const canDownloadFile = section ? section.canDownloadFile : false;

    const {searchData, totalCount, setTotalCount, setPaginationConfig, setSearchConfig} = useSearch();
    const [working, setWorking] = useState(true);

    useEffect(() => {
        return () => {
            OffersChoiceResultService.clearResources(OffersChoiceResultService.OFFER_CHOICE_RESULT_LIST_RESOURCE_ID);
        }
    }, [])

    useEffect(() => {
        setWorking(true);
        const {pagination, search} = searchData;
        OffersChoiceResultService.getChoiceResultList(demandId, pagination, search).then(() => (setWorking(false)));
        // eslint-disable-next-line
    }, [searchData, demandId])

    useDidUpdateEffect(() => {
        if (offerChoiceResultList?.totalCount !== undefined) {
            setTotalCount(offerChoiceResultList.totalCount)
        }
    }, [offerChoiceResultList?.totalCount]);

    if (!offerChoiceResultList) return <Loading/>;
    return (
        <div className={classes.root}>
            <DemandValidationMessages editable={editable} section={section}/>
            <BasicSearch
                label={Tr('search_part')}
                searchInProgress={working}
                doSearch={setSearchConfig}
            />

            {!offerChoiceResultList?.items.length ?
                <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>
                :
                <>
                    <OfferChoiceResultTable editable={editable} offerChoiceResultList={offerChoiceResultList} working={working} demandId={demandId} canDownloadPaper={canDownloadPaper} canDownloadFile={canDownloadFile}/>
                    <Pagination config={searchData.pagination} setConfig={setPaginationConfig} totalCount={totalCount} disabled={working}/>
                </>
            }
        </div>)
}

export default connect((state) => ({
    offerChoiceResultList: state.resources[OffersChoiceResultService.OFFER_CHOICE_RESULT_LIST_RESOURCE_ID],
    demandValidation: state.resources.demandValidation
}), {})(withRouter(OffersChoiceResult));